import { WorkflowPresetKinds } from "../kinds";
import { ReceptionDetailSearchCondition } from "./ReceptionDetailSearchCondition";

export class ReceptionDetailPresetSearchCondition {
  key: string;
  name: string;
  condition: ReceptionDetailSearchCondition;
  presetKind: WorkflowPresetKinds;
  index: number;
  departmentId: string;
  isDefaultSelected: boolean;
  isStatusTabEnabled: boolean;

  constructor() {
    this.condition = new ReceptionDetailSearchCondition();
    this.name = "";
  }

  clone(): ReceptionDetailPresetSearchCondition {
    const newObj = new ReceptionDetailPresetSearchCondition();
    newObj.key = this.key;
    newObj.name = this.name;
    newObj.condition = this.condition.clone();
    newObj.presetKind = this.presetKind;
    newObj.index = this.index;
    newObj.departmentId = this.departmentId;
    newObj.isDefaultSelected = this.isDefaultSelected;
    newObj.isStatusTabEnabled = this.isStatusTabEnabled;
    return newObj;

  }
}
